export default "__VITE_ASSET__DfWebA08__"